module.exports = __webpack_public_path__ + "static/img/伙伴客户-南京总医院.37895cdd.png";